import { Typography } from "antd";
import React from "react";

const { Paragraph } = Typography;

export default function CardDescription({ text }) {
  return (
    <Paragraph className="description-text-box">
     {text}
    </Paragraph>
  );
}
